import { render, staticRenderFns } from "./ShowClientPackages.vue?vue&type=template&id=c2f90326"
import script from "./ShowClientPackages.vue?vue&type=script&lang=js"
export * from "./ShowClientPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports